import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/lib/campaign";
import { Reveal } from "./Reveal";

export const FAQSection = () => (
  <section id="faq" data-testid="faq-section" className="scroll-mt-20 py-16 sm:py-24">
    <div className="max-w-3xl mx-auto px-4 sm:px-6">
      <Reveal>
        <h2 className="font-serif-brand text-3xl sm:text-4xl font-medium text-[var(--brand-navy)]">
          Common questions
        </h2>
      </Reveal>
      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-8">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-[var(--brand-gold-soft)]">
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left text-base sm:text-lg font-semibold text-[var(--brand-navy-deep)] hover:no-underline hover:text-[var(--brand-navy)]"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-base leading-relaxed text-[var(--brand-navy-deep)]">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
